import { Component, WritableSignal, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ResourceService } from '../../services/resource.service';
import { take, tap } from 'rxjs';
import { AuthService } from '@core/services/auth.service';
import { IImpactVideoResponse } from '../../interfaces/iimpact-video';
import { Role } from '@core/enums/roles';
import { ILoginResponse } from '@core/interfaces/ilogin-response';
import { Card } from '@core/models/card';
import { CardService } from '@core/services/card.service';

@Component({
  selector: 'prism-impact-video',
  templateUrl: './impact-video.component.html',
  styleUrl: './impact-video.component.scss'
})
export class ImpactVideoComponent {
  private router = inject(Router);
  private resourceService = inject(ResourceService);
  private authService = inject(AuthService);
  private cardService = inject(CardService);

  currentUser: WritableSignal<ILoginResponse | null> = this.authService.currentUserInfo;
  resources: IImpactVideoResponse[] = [];
  canAdd: boolean = false;
  sasToken: string = '';

  viewImpactVideo = (card: Card) => this.cardService.viewCard(card.id!, 'resources/impact-video/view/');

  get impactVideoList(): Card[] {
    if (this.resources.length === 0) return [];
    return this.cardService.mapCardDataToDataList('impact-videos', this.resources, this.sasToken);
  }


  ngOnInit(): void {
    this.canAdd = this.currentUser()?.roleId === Role.SystemAdmin;
    this.getSasToken();
  }

  getResources(): void {
    this.resourceService.getAllImpactVideos().pipe(
      take(1),
      tap((res: IImpactVideoResponse[]) => {
        this.resources = res;
      })
    ).subscribe();
  }

  getSasToken(): void {
    this.authService.fetchSasToken('impact-videos', (token) => {
      this.sasToken = token;
      this.getResources();
    });
  }

  goToResourcesForm(): void {
    this.router.navigateByUrl('resources/impact-video/form');
  }
}